/*
 * @Descripttion: 人群选择
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect, useContext } from 'react';
import { Input, Button, Form } from '@alifd/next';
import moment from 'moment';
import { store } from '@ice/stark-data';
import styles from '../../../index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import { CanvasService } from '@/service';
import SelectCrowd from '@/components/SelectCrowd';
import { ActivityContext, PageType } from '../../../../Edit';

export default ({
  allNodeData = [],
  activityInfo = {},
  initData = {},
  runState = {},
  currentNode = {},
  changeData = (data) => {},
  onCancel = () => {},
  validate = () => {},
  getAllNodeIds = [],
}) => {
  const {
    graph,
  } = useContext(ActivityContext);
  // 控制选择人群弹窗变量
  const [isSelectCrow, setSelectCrow] = useState(false);
  // 选择的人群是 1-策略、重点人群  2-包（策略、重点人群需预计算人数，包不需要）
  // 是否有刷新按钮
  const [needPreCalc, setNeedPreCalc] = useState(false);
  // 组件内部的数据
  const [data, setData] = useState({});
  // 是否展示执行中
  const [execution, setExecution] = useState(false);

  // 初始化表单数据 后端需要时间戳格式，需在表单内部自己维护  activityInfo.executionPlan.type:活动类型 1-单次执行，2-循环执行
  useEffect(() => {
    if (activityInfo.executionPlan.type === 1) {
      const formData = { ...initData };
      if (
        formData.crowdName &&
        formData.crowdType !== 'instance' &&
        formData.crowdType !== 'PACKAGE' &&
        formData.crowdType !== 2
      ) {
        setNeedPreCalc(true);
      }
      formData.executionTime = activityInfo.executionPlan.crowdStartTime
        ? moment(activityInfo.executionPlan.crowdStartTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        : new Date().toLocaleDateString().replace(/\//g, '-');
      setData({
        ...formData,
        cycleType: activityInfo.executionPlan.type,
      });
    } else {
      const formData = { ...initData };
      if (
        formData.crowdName &&
        formData.crowdType !== 'instance' &&
        formData.crowdType !== 'PACKAGE' &&
        formData.crowdType !== 2
      ) {
        setNeedPreCalc(true);
      }
      formData.executionTime = formData.executionTime
        ? (formData.executionTime - formData.executionMinute * 60000) / 3600000
        : 0; // 循环执行的活动，填写的是延时小时分钟，获取毫秒值转为小时数
      setData({
        ...formData,
        cycleType: activityInfo.executionPlan.type,
      });
    }
  }, []);

  /**
   * 选择人群包
   */
  const selectCrowsId = async (item, bool) => {
    const bufData = {
      crowdId: item.crowdType === 1 ? item.strategyId : item.crowdId,
      crowdName: item.name, // 由于有些渠道生成的人群名称超过32个字，所以裁一下
      crowdType: item.crowdType === 1 ? 'strategy' : 'instance',
      crowdNum: '',
      name: item.name,
      // crowdKeyId: item.crowdKeyId, // 所选的人群的序号id
      description: item.description, // 所选的人群描述
      peopleName: item.name, // 所选的人群名 【上面三个，是为了后续人群分析节点存个值】
    };
    setNeedPreCalc(item.crowdType === 1); // 如果是人群策略或重点人群，展示预计算刷新按钮
    if (item.crowdType === 2 || item.crowdType === 'PACKAGE') {
      // 人群类型是人群包，直接获取人数，不需要预计算
      onChange({
        ...bufData,
        crowdNum: item.size,
      });
    } else {
      setExecution(true); // 展示执行中状态
      await CanvasService.preCalcPeopleCount({ strategyId: bufData.crowdId })
        .then((res) => {
          setExecution(false); // 预计算完成，取消执行中状态
          onChange({ ...bufData, crowdNum: res.data });
        })
        .catch((e) => {
          console.log(e);
        });
    }
    setSelectCrow(false);
  };
  /**
   * 预计算人群
   */
  const preCalc = () => {
    setExecution(true); // 展示执行中状态
    CanvasService.preCalcPeopleCount({ strategyId: data.crowdId })
      .then((res) => {
        setExecution(false); // 预计算完成，取消执行中状态
        onChange({ crowdNum: res.data });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  /**
   * 点击确认
   */
  const confirm = async () => {
    const formData = { ...data };
    if (activityInfo.executionPlan.type === 1) {
      formData.executionTime = activityInfo.executionPlan.crowdStartTime
        ? moment(activityInfo.executionPlan.crowdStartTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        : new Date().toLocaleDateString().replace(/\//g, '-');
    } else {
      formData.executionTime = 0 * 3600000 + formData.executionMinute * 60000; // 循环执行的活动，填写的是延时小时数和分钟数，需要转成毫秒值
    }
    try {
      await Promise.all(
        Object.keys(validate).map(async (validator) => {
          // 最终校验数据是否填写完整，然后提交给全局
          try {
            if (validator in data) {
              if (validator === 'name') {
                await validate[validator](
                  data[validator],
                  allNodeData,
                  currentNode,
                  getAllNodeIds
                );
              }
              else {
                await validate[validator](formData[validator]);
              }
            }
          } catch (e) {
            throw new Error(e);
          }
        })
      );
      // 人群包已选时，给节点fillComplete字段赋值为true，用于判断人群选择节点是否该显示右侧箭头，是否可连接其他节点
      if(formData.crowdId !== ''){ // TODO:暂时写法，promise校验有问题
        graph.updateItem(currentNode.nodeId, {
          fillComplete: true,
          content: formData.crowdId
        });
      }
      changeData(formData);
    } catch (e) {
      const ar = e.message.split(':');
      LzMsg.error(ar[ar.length - 1]);
    }
  };

  /**
   * 点击退出
   */
  const cancel = () => {
    onCancel();
  };

  const formItemLayout = {
    labelCol: {
      span: 5,
    },
  };

  return (
    <div>
      <Form
        className={`${styles.formDiv} ${styles.strategyDiv} canvasDialog`}
        {...formItemLayout}
      >
        <Form.Item
          // hasFeedback
          label="节点名称："
          required
          requiredMessage="请输入节点名称"
          style={{ padding: '30px 30px 0 30px' }}
        >
          <Input
            className="formItemWidth"
            name="strategyName"
            placeholder="请输入节点名称"
            trim
            size="small"
            value={data.name}
            onChange={(name) => onChange({ name })}
            showLimitHint
            maxLength={32}
          />
        </Form.Item>
        <Form.Item
          label="选择人群："
          required
          requiredMessage="请选择人群"
          style={{ padding: '0 30px' }}
        >
          <div className={styles.stragegySelectCrowd}>
            <div
              className={styles.crowdDiv}
              onClick={() => setSelectCrow(true)}
            >
              {data.crowdName ? data.crowdName : '点击选择人群'}
            </div>
            <div style={{ color: 'rgba(156,167,182,1)' }}>
              <span style={{ float: 'left' }}>人群数量：</span>
              <span
                style={{
                  display: !execution ? 'block' : 'none',
                  color: 'rgba(156,167,182,1)',
                  float: 'left',
                }}
              >
                {data.crowdNum}人
              </span>
              <span
                style={{
                  display: execution ? 'block' : 'none',
                  color: 'rgba(156,167,182,1)',
                  float: 'left',
                }}
              >
                loading...
              </span>
            </div>
            <span
              className="iconfont icon-icon666-34"
              style={{
                display: needPreCalc ? 'block' : 'none',
                color: '#3399FF',
                cursor: 'pointer',
              }}
              onClick={preCalc}
            />
          </div>
        </Form.Item>
        {activityInfo.executionPlan.type === 1 && (
          <Form.Item label="执行时间：" style={{ padding: '0 30px' }}>
            <span style={{ lineHeight: '30px' }}>
              {!activityInfo.executionPlan.crowdStartTime
                ? moment(new Date().getTime()).format('YYYY-MM-DD')
                : moment(activityInfo.executionPlan.crowdStartTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
            </span>
          </Form.Item>
        )}
        <hr />
        <div style={{ padding: '15px 30px 0 0', height: '60px' }}>
          <Button
            type="primary"
            className={`submit-btn ${styles.w88}`}
            onClick={confirm}
            style={{ float: 'right' }}
          >
            确认
          </Button>
          <Button
            type="normal"
            className={`cancel-btn ${styles.mr10} ${styles.w88}`}
            onClick={cancel}
            style={{ float: 'right' }}
          >
            取消
          </Button>
        </div>
      </Form>

      {isSelectCrow && (
        <SelectCrowd
          // type='1,3,5'
          // visible={isSelectCrow}
          showDialog={isSelectCrow}
          closeDialog={() => setSelectCrow(false)}
          selectCrowd={(item, bool) => {
            selectCrowsId(item, bool);
          }}
          // selected={(item, bool) => {
          //   selectCrowsId(item, bool);
          // }}
          // selected={(
          //   data: {
          //     id: string;
          //     name: string;
          //     intro: string;
          //     type: string;
          //     size: number;
          //     createDate: string;
          //   },
          //   selected: boolean,
          // ) => {
          //   {
          //     getCrowdSelectedData(data, selected);
          //   }
          // }}
          showPackageListRange="SHOWALL"
        />
      )}
    </div>
  );
};
